import { Form } from "antd";

export default function Project({ form }) {
  return <Form layout="vertical" name="projectForm" form={form}></Form>;
}
